import React, {Component} from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import ApolloClient from 'apollo-boost';
import {ApolloProvider} from '@apollo/react-hooks';
import gql from "graphql-tag";

import Header from "./components/Header";
import HomePage from "./pages/Home";
import DownloadsPage from "./pages/Downloads";
import AuditPage from "./pages/Audit";

const client = new ApolloClient({
  uri: '/graphql',
});

const SESSION = gql`{
  session {
    userID
    email
    name
  }
}`;

function hasError(reason, value) {
  if (reason) {
    if (reason.graphQLErrors) {
      for (const i in reason.graphQLErrors) {
        const err = reason.graphQLErrors[i];
        if (err && err.message === value) {
          return true;
        }
      }
    }
    if (reason.networkError && reason.networkError && reason.networkError.statusCode) {
      if (reason.networkError.statusCode === 403) {
        return true;
      }
    }
  }
  return false;
}

class App extends Component {
  constructor() {
    super();
    this.state = {data: {}};
  }

  componentDidMount() {
    client.query({query: SESSION})
      .catch(reason => {
        if (hasError(reason, 'not authorized')) {
          console.log('redirecting');
          document.location = '/login';
        }
      })
      .then(result => {
        if (result && result.data) {
          this.setState({data: result.data});
        }
      });
  }

  render() {
    let session = undefined;
    if (this.state && this.state.data && this.state.data.session) {
      session = this.state.data.session;
    }

    return (
      <ApolloProvider client={client}>
        <Router>
          <Header session={session}/>
          <div className="content">
            <Switch>
              <Route path="/downloads">
                <DownloadsPage/>
              </Route>
              <Route path="/audit">
                <AuditPage/>
              </Route>
              <Route path="/authorize">
                <HomePage/>
              </Route>
              <Route path="/">
                <HomePage/>
              </Route>
            </Switch>
          </div>
        </Router>
      </ApolloProvider>
    )
  }
}

export default App;
